export const CONNECTSTATUS = {
  connect: 'connect',
  disconnect: 'disconnect',
  init: 'init',
};
export const SCANSTATUS = {
  init: 'init',
  scanned: 'scanned',
};

export const CHECKIDENTIFIER = 'CUI-WSS';

export const CLIENTREQUEST = {
  FeedTimeoutMillisInt: 10 * 1000,
  MICRFmtCode: '6200',
  MICRQuality: '90',
  ImageSide: 'BOTH',
  ImageColor: 'GRAY8',
  ImageResolution: '100X100',
  WriteImagesToLocalFile: '',
  PrintOnCheck: 'BACK',
  PrintFont: 'INTFONT1',
  PrintStyle: 'NORMAL',
  PrintRate: '90',
};

export const connectStatusConfigs = {
  [CONNECTSTATUS.connect]: {
    id: 'checkout.lib.components.payment.check.ready',
    classes: 'connect ready-color',
    icon: 'ic-check-r',
    type: 'success',
  },
  [CONNECTSTATUS.init]: {
    id: 'checkout.lib.components.payment.check.init',
    classes: 'round warning-color',
    icon: 'waiting',
    type: 'warning',
  },
  [CONNECTSTATUS.disconnect]: {
    id: 'checkout.lib.components.payment.check.notReady',
    classes: 'round unready-color',
    icon: 'ic-cross-r',
    type: 'danger',
  },
};

export const magtekResponseCode = {
  usbGetDataFailed: '67',
  timeout: '250',
  success: '0',
  micrDecode: 'OK',
};

export const magtekErrorMessage = {
  [magtekResponseCode.usbGetDataFailed]: 'checkout.lib.components.payment.check.usbGetDataFailed',
  [magtekResponseCode.timeout]: 'checkout.lib.components.payment.check.warning',
  success: 'checkout.lib.components.payment.check.scanError',
  default: 'checkout.lib.components.payment.check.default',
};
